import { Grid, Typography } from "@mui/material";
import MainLayout from "../layouts/Mainlayout";

export default function Activities() {
  const activities = [
    "Tree Plantation 🌳",
    "Seed Collection 🌱",
    "Jungle Visits 🏕",
    "Butterfly Gardens 🦋",
    "School Lectures 🎓",
    "Rare Tree Protection 🌲",
  ];

  return (
    <MainLayout>
      <Typography variant="h4" align="center" gutterBottom>
        Our Activities
      </Typography>

      <Grid container spacing={3}>
        {activities.map((item, i) => (
          <Grid item xs={12} sm={6} md={4} key={i}>
            <div className="p-6 rounded-xl bg-gradient-to-br from-green-100 to-emerald-100 shadow">
              {item}
            </div>
          </Grid>
        ))}
      </Grid>
    </MainLayout>
  );
}